import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IInvite } from 'src/app/common/model/invites.model';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvitesService {
  constructor(private http: HttpClient) {}

  public getAllInvites(): Observable<ISibasiHTTPResponse<IInvite[]>> {
    return this.http.get<ISibasiHTTPResponse<IInvite[]>>(
      `${environment.api_url}organization/user/invites`
    );
  }

  public getInvitesByEmail({
    email
  }: {
    email: string;
  }): Observable<ISibasiHTTPResponse<IInvite[]>> {
    return this.http.post<ISibasiHTTPResponse<IInvite[]>>(
      `${environment.api_url}organization/invites`,
      { email }
    );
  }

  public acceptInvite(
    inviteArr: any
  ): Observable<ISibasiHTTPResponse<[{ inviteId: string; status: string }]>> {
    return this.http.post<ISibasiHTTPResponse<[{ inviteId: string; status: string }]>>(
      `${environment.api_url}organization/invites/action`,
      inviteArr
    );
  }
  public rejectInvite(inviteArr: any): Observable<ISibasiHTTPResponse<IInvite>> {
    return this.http.post<ISibasiHTTPResponse<IInvite>>(
      `${environment.api_url}organization/invites/action`,
      inviteArr
    );
  }

  public getInvites(email: {
    email: string | undefined;
  }): Observable<ISibasiHTTPResponse<IInvite[]>> {
    return this.http.post<ISibasiHTTPResponse<IInvite[]>>(
      `${environment.api_url}organization/invites`,
      email
    );
  }

  public submitFeedback(data: any): Observable<any> {
    return this.http.post(`${environment.api_url}feedback`, data);
  }
}
